import { cAdminDeliveryItems }      from "./admin-delivery-items";
import { cAdminDeliveryItemsOrder } from "./admin-delivery-items-order";

export class cAdminDeliveryItemsCustomer {

  div      = document.createElement('div');
  h2_name  = document.createElement('h2');

  orders : cAdminDeliveryItemsOrder[] = [];

  constructor(parent: HTMLElement, data: DeliveryCustomerGroup, page: cAdminDeliveryItems) {

    // ---- Structure ----
    parent.append(this.div);
      this.div.append(this.h2_name);

    // ---- Init ----
    this.div.classList.add('c-customer');

    // The id is left out when it is the name itself, so that no "p-547 (p-547)" appears.
    // Repeated in every order heading, so a printed or scrolled page stays readable.
    const customerLabel =
      data.isNoCustomer || !data.resolved
      ? data.customerName
      : `${data.customerName} (${data.customer_id})`;

    this.h2_name.innerText = customerLabel;

    for (const order of data.orders) {
      this.orders.push(new cAdminDeliveryItemsOrder(this.div, order, page, customerLabel));
    }
  }
}
